import { useEffect, useState } from "react";
import Popup from "../../../../../../components/general/Popup.tsx";
import { fieldLabelClasses, fieldVariants } from "../../../../../../components/general/fieldStyles.ts";
import { cn } from "../../../../../../lib/utils.ts";

const MAX_REJECTION_REASON_LENGTH = 2000;

interface RejectVatDeclarationPopupProps {
    open: boolean;
    onClose: () => void;
    onReject: (reason: string) => void;
    isRejecting: boolean;
}

export function RejectVatDeclarationPopup({ open, onClose, onReject, isRejecting }: RejectVatDeclarationPopupProps) {
    const [reason, setReason] = useState('');

    useEffect(() => {
        if (open) {
            setReason('');
        }
    }, [open]);

    const trimmedReason = reason.trim();

    return (
        <Popup
            open={open}
            onClose={onClose}
            onConfirm={() => {
                if (trimmedReason && !isRejecting) {
                    onReject(trimmedReason);
                }
            }}
            title="BTW-aangifte afwijzen"
            confirmButtonDisplayLabel="Afwijzen"
            confirmButtonDisabled={!trimmedReason || isRejecting}
            variant="danger"
        >
            <div className="mt-2 space-y-2">
                <p className="text-sm text-gray-700">
                    Je boekhouder ziet je reden en kan de aangifte daarna aanpassen.
                </p>
                <label htmlFor="vat-declaration-rejection-reason" className={fieldLabelClasses}>
                    Reden
                </label>
                <textarea
                    id="vat-declaration-rejection-reason"
                    value={reason}
                    onChange={(event) => setReason(event.target.value)}
                    rows={4}
                    maxLength={MAX_REJECTION_REASON_LENGTH}
                    aria-required="true"
                    aria-describedby="vat-declaration-rejection-reason-hint"
                    className={cn(fieldVariants({ size: "multi" }), "px-3 py-2")}
                    placeholder="Bijvoorbeeld: het bedrag bij 1a klopt niet."
                />
                <p id="vat-declaration-rejection-reason-hint" className="text-xs text-gray-500">
                    Een reden is verplicht (maximaal {MAX_REJECTION_REASON_LENGTH} tekens).
                </p>
            </div>
        </Popup>
    );
}
